module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.1ec1b222.eot";